import './App.css';
import askLogo from './images/askLogo.png'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={askLogo} className="App-logo" alt="logo" />
        <p>
          Ajay Kumar
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
